<div id="home" class="surface-0 overflow-hidden">
  <header
    class="py-4 px-4 mx-0 md:mx-6 lg:mx-8 lg:px-8 flex align-items-center justify-content-between relative lg:static"
  >
    <a class="flex align-items-center">
      <span
        class="text-900 font-medium text-2xl line-height-3 mr-8"
        >Observations</span
      >
    </a>
    <p-button (click)="onLogoutClick()" label="Logout" styleClass="p-button-text"></p-button>
  </header>

  <div class="min-h-screen">
    <router-outlet></router-outlet>
  </div>
</div>
